import clsx from 'clsx';

interface JobBoardWrapperProps {
  isFiltersSidebarOpen: boolean;
  children: React.ReactNode;
}

const JobBoardWrapper: React.FC<JobBoardWrapperProps> = ({ isFiltersSidebarOpen, children }) => (
  <div className={clsx('flex flex-grow flex-col', isFiltersSidebarOpen && 'overflow-y-hidden')}>{children}</div>
);

export default JobBoardWrapper;
